$shm_tests_screenshots $mol_page
	result null
	manifest_uri \
	visual* null
	title \Скриншоты и диффы
	body <= screenshot_rows /$mol_view
	Summary $mol_text
		text <= summary_text \
	Visual* $shm_tests_visual
		comparison <= visual*
		manifest_uri <= manifest_uri
	Screenshot* $mol_view
		sub /
			<= Description* $mol_text
				text <= screenshot_description* \
			<= Image* $mol_image
				uri <= screenshot_uri* \
				title <= screenshot_description* \
	Empty $mol_paragraph
		title \Для этого запуска скриншоты не записаны.
